import { FreePlanCardProps } from ".."

type ButtonVariant =
  | "static"
  | "is-active-plan"
  | "show-downgrade-modal"
  | "disable-downgrade-modal"
  | "pending-downgrade"
export type UsePrimaryButtonVariantPayload = ButtonVariant

type UsePrimaryButtonVariantInput = FreePlanCardProps

export const usePrimaryButtonVariant = ({
  variant,
  isCancelled = false,
  periodEnd,
  activePlanType,
}: UsePrimaryButtonVariantInput): UsePrimaryButtonVariantPayload => {
  if (variant === "dynamic") {
    //
    // 1. Enterprise plan should not be downgradable to Free plan
    //
    if (activePlanType === "ENTERPRISE") {
      return "disable-downgrade-modal"
    }

    //
    // 2. The user is on this free plan, button will state "Current plan"
    //
    if (activePlanType === "FREE") {
      return "is-active-plan"
    }

    //
    // 3. The user has downgraded their plan to FREE, button will state "Pending downgrade"
    //
    if (isCancelled && periodEnd) {
      return "pending-downgrade"
    }

    //
    // 4. The user has an active BUSINESS plan and will be able to downgrade to FREE
    //
    return "show-downgrade-modal"
  }

  //
  // 5. No dynamic values available, used on the static Pricing page, button will state "Get started"
  //
  return "static"
}
